"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListLayoutContext = void 0;
exports.useListLayoutStore = useListLayoutStore;
exports.resolveCard = resolveCard;
const react_1 = require("react");
const shared_1 = require("@forecastify/shared");
exports.ListLayoutContext = (0, react_1.createContext)(null);
function useListLayoutStore() {
    return (0, react_1.useContext)(exports.ListLayoutContext);
}
const BADGE_KEYS = /^(status|state|severity)$/u;
const AVATAR_KEYS = /^(owner|pm|assignee|member|who|author|actor|person|name)$/u;
/**
 * ┌───────────────────────────────────────────────────────────────────────┐
 * │ ⚠️⚠️ THE CARD, RESOLVED — the list's spec, the person's choice, and   │
 * │ the list's real columns, in that order of trust.                      │
 * └───────────────────────────────────────────────────────────────────────┘
 *
 * A stored slot naming a column the list no longer has — a metafield deleted, a column renamed —
 * falls back to the list's default rather than drawing an empty corner nobody chose. A list with no
 * spec at all still gets a sensible card: its first column as the title, a status-like column as
 * the badge, a person-like one as the avatar and the next four shown columns as details.
 */
function resolveCard(columns, spec, stored) {
    const keys = new Set(columns.map((column) => column.key));
    const known = (key) => key !== null && key !== undefined && keys.has(key) ? key : null;
    const title = known(spec?.title) ?? columns[0]?.key ?? '';
    const context = known(spec?.context);
    const fixed = new Set([title, context]);
    const free = (key) => {
        const one = known(key);
        return one === null || fixed.has(one) ? null : one;
    };
    const derived = () => {
        const pool = columns.filter((column) => !fixed.has(column.key));
        const badge = pool.find((column) => BADGE_KEYS.test(column.key))?.key ?? null;
        const avatar = pool.find((column) => column.key !== badge && AVATAR_KEYS.test(column.key))?.key ?? null;
        const details = pool
            .filter((column) => column.key !== badge && column.key !== avatar && column.defaultHidden !== true)
            .slice(0, shared_1.CARD_DETAIL_SLOTS)
            .map((column) => column.key);
        return { badge, avatar, details, footer: null };
    };
    const base = spec?.defaults === undefined
        ? derived()
        : {
            badge: spec.defaults.badge ?? null,
            avatar: spec.defaults.avatar ?? null,
            details: spec.defaults.details ?? [],
            footer: spec.defaults.footer ?? null,
        };
    const chosen = stored ?? base;
    return {
        title,
        context,
        badge: free(chosen.badge),
        avatar: free(chosen.avatar),
        details: Array.from({ length: shared_1.CARD_DETAIL_SLOTS }, (_, at) => free(chosen.details[at])),
        footer: free(chosen.footer),
    };
}
//# sourceMappingURL=list-layout.js.map